//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const WritableODataDatasources: FeatureFlag = {"Id":"WritableODataDatasources","Label":"Writable OData-linked datasources","Impact":"Allow OData-linked datasource to configuration to allowed for datasource modification activities.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
